import { Component, OnInit, ViewChild } from "@angular/core";
import { ApiServicesService } from "../../../Services/api-services.service";

import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
@Component({
  selector: "app-attendesslist",
  templateUrl: "./notpaid-attendees-list.component.html",
  styleUrls: ["./notpaid-attendees-list.component.scss"],
})
export class NotpaidAttendeesList implements OnInit {
  pageSizes = [15, 30, 45, 70];
  displayedColumns: string[] = [
    "OrderId",
    "Full Name",
    "Email Id",
    "Price Type",
    "Total Amount",
    "TransAction Id",
    "Payment Type",
    "State",
    "Date",
    "Status",
  ];

  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private apiCall: ApiServicesService) {}

  ngOnInit(): void {
    this.getAttendess();
  }

  getAttendess() {
    this.apiCall.getNotPaidAttendees(true).subscribe((attendess) => {
      this.dataSource = new MatTableDataSource();
      this.dataSource.data = attendess;
      this.dataSource.paginator = this.paginator;
    });
  }
  attendeesFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
